/* eslint-disable no-param-reassign */
import { IStats, IVuexRootState } from "@/types";




export default {


  popStats(state: IVuexRootState) {
    return state.stats.pop()
  },

  unshiftStats(state: IVuexRootState, newRecord: IStats) {
    state.stats.unshift(newRecord);
  },

  updateTodaysStatsRecord(state: IVuexRootState, statsRecord: IStats){
    // splice, not index assignment, so Vue sees the change
    state.stats.splice(0, 1, statsRecord);
  }



}